export default __webpack_public_path__ + "static/media/kaleido.19f8ad6e.png";